import { render, staticRenderFns } from "./Ijtimoiy.vue?vue&type=template&id=10c5c8ec&scoped=true&"
import script from "./Ijtimoiy.vue?vue&type=script&lang=js&"
export * from "./Ijtimoiy.vue?vue&type=script&lang=js&"
import style0 from "./Ijtimoiy.vue?vue&type=style&index=0&id=10c5c8ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c5c8ec",
  null
  
)

export default component.exports